/**
 * @deprecated 根据webpack发布时定义的默认语言,选择对应的AngularJs locale配置完成本地化设置
 */
import { appConfig } from "@env/app-config";
import { localProvideFn as localProvideFn_en } from "./config/angular-locale_en";
import { localProvideFn as localProvideFn_zh_cn } from "./config/angular-locale_zh-cn";

const LOCALE_PROVIDE_FN = {
    en: localProvideFn_en,
    zh_CN: localProvideFn_zh_cn
}

const ngLocaleModule = "ngLocale";

angular.module(ngLocaleModule, [], ["$provide", LOCALE_PROVIDE_FN[appConfig.DEFAULT_LANGUAGE]]);

export { ngLocaleModule };